/**
 * Styled components for SourceListVertical
 */

import styled from 'styled-components';

import { withAlpha } from '../../styles/colorUtils';
import { ocScrollbarStyles } from '../../styles/OcScrollbar.styled';

/**
 * Main container for the vertical source list (25% width)
 */
export const SourceListContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-left: ${({ theme }) => `2px solid ${withAlpha(theme.color.chatBorder, 0.5)}`};

  margin-bottom: -10px;
  margin-top: -64px;
  margin-left: 16px;
  margin-right: -8px;
  display: flex;
  width: 275px;

  .ai-sources-spacer {
      margin-top: 2px;
  }
  .hl-scroll-semi-transparent-container {
      padding-right: 4px;
  }
`;

export const SourceListSpacer = styled.div`
  height: 11px;
`;

/**
 * Header showing "Sources (count)"
 */
export const SourceListHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 16px;
  font-size: ${({ theme }) => theme.font.size.medium};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  color: ${({ theme }) => theme.color.chatPanel};
  flex-shrink: 0;

  .ai-info-tooltip-container {
    display: flex;
    justify-content: center;
  }
`;

/**
 * Scrollable container for source cards
 */
export const SourceListScrollContainer = styled.div`
  overflow-y: auto;
  padding: 2px 4px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  /* Shared OC scrollbar styling - override parent with chatPanel color */
  /* Use && to increase specificity and override WithVerticalSources wildcard selector */
  && {
    ${({ theme }) => ocScrollbarStyles(withAlpha(theme.color.chatPanel, 0.5))}
  }
`;
